// src/data/artworks.js

import cig_2 from "../Art/images/cig_2.jpg";
import cig_4 from "../Art/images/CIG_4.png";
import crescent_bay from "../Art/images/CRESCENT_BAY_3x5.jpg";
import translation from "../Art/images/IN_TRANSLATION.png";
import frog from "../Art/images/FROG.png";
import oranges from "../Art/images/Oranges.png";
import dinner from "../Art/images/DINNER.jpg";
import dinner2 from "../Art/images/DINNER2.png";
import cafe from "../Art/images/CAFE.jpg";
import eliot from "../Art/images/TS_ELIOT.png";
import snacks from "../Art/images/SNACKS.png";
import untitled from "./images/Untitled.png";
import untitled2 from "./images/Untitled2.jpg";
import untitled3 from "./images/Untitled3.jpg";
import monterey1 from "./images/MONTEREY1.png";
import monterey2 from "./images/MONTEREY2.png";
import viewofthegreen1 from "./images/VIEW_OF_THE_GREEN.png";
import viewofthegreen2 from "./images/VIEW_OF_THE_GREEN_1.jpg";
import sunshine from "./images/SUNSHINE.jpg";
import sunshine2 from "./images/SUNSHINE2.jpg";
import bluemoon from "./images/BLUE_MOON.jpg";
import walden from "./images/WALDEN.png";
import stilllife from "./images/STILL_LIFE.jpg";
// Sample structure with placeholder descriptions and a single image per artwork.
// You can replace each `images` array with multiple versions or alternate angles.

export const artworks = [
  {
    id: "walden",
    title: "Walden",
    images: [walden],
    medium: "Oil on canvas",
    size: "24x36 in.",
    year: "2026",
    description: "",
    status: "available"
  },
  {
    id: "blue_moon",
    title: "Blue Moon",
    images: [bluemoon],
    medium: "Oil on canvas",
    size: "16x18 in.",
    year: "2026",
    description: "",
    status: "available"
  },
  {
    id: "still_life",
    title: "Still Life",
    images: [stilllife],
    medium: "Oil on canvas",
    size: "16x18 in.",
    year: "2026",
    description: "",
    status: "sold"
  },
  {
    id: "sunshine",
    title: "Sunshine on Sick Days",
    images: [sunshine, sunshine2],
    medium: "Oil on canvas",
    size: "11x14 in.",
    year: "2026",
    description: "A quiet study of light, composition, and loneliness at the dinner table.",
    status: "reserved"
  },
  {
    id: "view_of_the_green",
    title: "View of the Green",
    images: [viewofthegreen1, viewofthegreen2],
    medium: "Oil on canvas",
    size: "36x48 in.",
    year: "2026",
    description: "A quiet study of light, composition, and loneliness at the dinner table.",
    status: "sold"
  },
  {
    id: "monterey",
    title: "Monterey",
    images: [monterey1, monterey2],
    medium: "Oil on canvas",
    size: "24x32 in.",
    year: "2025",
    description: "A quiet study of light, composition, and loneliness at the dinner table.",
    status: "reserved"
  },
  {
    id: "dinner",
    title: "Dinner Scene",
    images: [dinner, dinner2],
    medium: "Oil on canvas",
    size: "30x40 in.",
    year: "2025",
    description: "A quiet study of light, composition, and loneliness at the dinner table.",
    status: "reserved"
  },
  {
    id: "cafe",
    title: "Cafe Scene",
    images: [cafe],
    medium: "Oil on canvas",
    size: "TBD",
    year: "2025",
    description: "A loose, gestural exploration of urban solitude.",
    status: "available"
  },
  {
    id: "untitled",
    title: "Untitled",
    images: [untitled, untitled2, untitled3],
    medium: "Acrylic on canvas",
    size: "2x2",
    year: "2025",
    description: "A loose, gestural exploration of urban solitude.",
    status: "available"
  },
  {
    id: "oranges",
    title: "Oranges",
    images: [oranges],
    medium: "Oil on canvas",
    size: "12x16 in.",
    year: "2025",
    description: "A still life that plays with warm tones and soft edges."
  },
  {
    id: "eliot",
    title: "T.S. Eliot",
    images: [eliot],
    medium: "Oil on canvas",
    size: "12x16 in.",
    year: "2025",
    description: "A portrait tribute to T.S. Eliot and the poetic mindscape.",
    status: "sold"
  },
  {
    id: "frog",
    title: "What the Frog's Eye Tells the Frog's Brain",
    images: [frog],
    medium: "Oil on canvas",
    size: "12x16 in.",
    year: "2025",
    description: "Inspired by a foundational neuroscience paper on vision and perception.",
    status: "available"
  },
  {
    id: "translation",
    title: "In Translation",
    images: [translation],
    medium: "Oil on canvas",
    size: "1x1 in.",
    year: "2024",
    description: "An abstract representation of linguistic distance and layered meaning.",
    status: "available"
  },
  {
    id: "crescent_bay",
    title: "Crescent Bay",
    images: [crescent_bay],
    medium: "Oil on canvas",
    size: "3x5 in.",
    year: "2024",
    description: "Seascape evoking the stillness and curve of a half-moon bay.",
    status: "sold"
  },
  {
    id: "cig_4",
    title: "Cig #4",
    images: [cig_4],
    medium: "Oil on paper",
    size: "1x1",
    year: "2024",
    description: "A hazy moment captured in smoke and graphite contours.",
    status: "available"
  },
  {
    id: "cig_2",
    title: "Cig #2",
    images: [cig_2],
    medium: "Oil on paper",
    size: "1x1",
    year: "2024",
    description: "A hazy moment captured in smoke and graphite contours.",
    status: "available"
  },
  {
    id: "snacks",
    title: "Snack Plants",
    images: [snacks],
    medium: "Ink on paper",
    size: "8.5x11 in.",
    year: "2019",
    description: "Homage to the German Expressionist masterpiece, 'The Cabinet of Dr. Caligari.'",
    status: "available"
  }
];
